import { globalStorage } from './storage';

export const isLoggedIn = () => globalStorage.getStore('token') as boolean;
